import { render, staticRenderFns } from "./MatchingTypeHelpColumn.vue?vue&type=template&id=6b275e4e"
import script from "./MatchingTypeHelpColumn.vue?vue&type=script&lang=js"
export * from "./MatchingTypeHelpColumn.vue?vue&type=script&lang=js"
import style0 from "./MatchingTypeHelpColumn.vue?vue&type=style&index=0&id=6b275e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports